export enum TaxTypes {
  VAT = "VAT",
  NOVA_TOTAL = "NOVA_TOTAL",
  FRT = "FRT",
  GVT = "GVT",
  GST = "GST",
  HANDLING_FEE = "HANDLING_FEE",
  LESS_FRT = "LESS_FRT",
  LICENSE_FEE = "LICENSE_FEE",
  LICENSE_PLATE = "LICENSE_PLATE",
  REGISTRATION_FEE = "REGISTRATION_FEE",
  TAVAF = "TAVAF",
  _AGGREGATE_FEE = "_AGGREGATE_FEE",
  DELIVERY_FEE = "DELIVERY_FEE",
  DEALER_DELIVERY_FEE = "DEALER_DELIVERY_FEE",
  DEALER_DELIVERY_CHARGE = "DEALER_DELIVERY_CHARGE",
  VEHICLE_TAX = "VEHICLE_TAX",
  LUXURY_CAR_TAX = "LUXURY_CAR_TAX",
  STAMP_DUTY = "STAMP_DUTY",
  HYBRID_DISCOUNT = "HYBRID_DISCOUNT",
  RECORDING_FEE = "RECORDING_FEE",
  ADMINISTRATION_FEE = "ADMINISTRATION_FEE",
  REGISTRATION_PLATES = "REGISTRATION_PLATES",
  GENERAL_ISSUE_NAMEPLATE_FEE = 'GENERAL_ISSUE_NAMEPLATE_FEE',
  TAC_AMOUNT = "TAC_AMOUNT",
  ELECTRIC_VEHICLE_CONCESSION = "ELECTRIC_VEHICLE_CONCESSION",
  TRAFFIC_IMPROVEMENT_FEE = "TRAFFIC_IMPROVEMENT_FEE",
  CTP_AMOUNT = "CTP_AMOUNT",
  TIO_AMOUNT = "TIO_AMOUNT",
  PRESCRIBED_FLAT_FEE = "PRESCRIBED_FLAT_FEE",
  LIFETIME_SUPPORT_FUND = "LIFETIME_SUPPORT_FUND",
  EMERGENCY_SERVICES_LEVY = "EMERGENCY_SERVICES_LEVY",
  ROAD_SAFETY_LEVY = "ROAD_SAFETY_LEVY",
  MOTOR_TAX = "MOTOR_TAX",
  FIRE_LEVY = "FIRE_LEVY",
  MAIB_AMOUNT = "MAIB_AMOUNT",
  VIC_ROADS_INSPECTION_FEE = "VIC_ROADS_INSPECTION_FEE",
  VIC_ROADS_ONLINE_ADMIN_FEE = "VIC_ROADS_ONLINE_ADMIN_FEE",
  CIRCULATION_PERMIT = "CIRCULATION_PERMIT",
  MANDATORY_INSURANCE = "MANDATORY_INSURANCE",
  REGISTRATION_TAX = "REGISTRATION_TAX",
  PROCESSING_COST = "PROCESSING_COST",
  GREEN_TAX = "GREEN_TAX",
  TAG_CHARGE = "TAG_CHARGE",
  TAG_RETURN_CHARGE = "TAG_RETURN_CHARGE",
  FORUM_REGISTRATION_CHARGE = "FORUM_REGISTRATION_CHARGE",
  AUTHORIZED_COURTESY_CHARGE = "AUTHORIZED_COURTESY_CHARGE"
}
